module.exports = __webpack_public_path__ + "static/media/special education veiw icon.acfb8c8c.svg";